import { Group, Text, ActionIcon, Tooltip } from "@mantine/core"
import {
  IconArrowsSort,
  IconSortAscending,
  IconSortDescending,
} from "@tabler/icons-react"

import { ICON_STROKE } from "@costory/shared/const"

import { ICON_SIZE } from "@costory/front/components/dropdown"

export type SortBy = "cost" | "name"
export type SortOrder = "asc" | "desc"

interface SortHeaderProps {
  label: string
  column: SortBy
  sortBy: SortBy | null
  sortOrder: SortOrder | null
  onSort: (column: SortBy) => void
}

export function SortHeader({
  label,
  column,
  sortBy,
  sortOrder,
  onSort,
}: SortHeaderProps) {
  const isActive = sortBy === column

  const tooltipLabel = isActive
    ? sortOrder === "asc"
      ? `Sorted by ${label} ascending`
      : `Sorted by ${label} descending`
    : `Sort by ${label} ascending`

  const icon = isActive ? (
    sortOrder === "asc" ? (
      <IconSortAscending size={ICON_SIZE} stroke={ICON_STROKE} />
    ) : (
      <IconSortDescending size={ICON_SIZE} stroke={ICON_STROKE} />
    )
  ) : (
    <IconArrowsSort size={ICON_SIZE} stroke={ICON_STROKE} />
  )

  return (
    <Group gap={0} align="center">
      <Text size="xs" fw={500} c="dimmed" mr={4}>
        {label}
      </Text>
      <Tooltip label={tooltipLabel}>
        <ActionIcon
          variant="subtle"
          radius="xl"
          size="sm"
          onClick={() => onSort(column)}
          aria-label={`Sort by ${label}`}
          color={isActive ? "primaryHighlight" : "textMuted"}
        >
          {icon}
        </ActionIcon>
      </Tooltip>
    </Group>
  )
}
